import React, { useState, useCallback } from 'react';
import { Chart, Series, Legend, Tooltip,
  ArgumentAxis, ValueAxis, Label} from 'devextreme-react/chart'
import {SIFReportingCompanies, SIFFilter, SIFMap} from '../'
import { groupBy } from '../../utils/miscUtil';

export default function SIFEventsByBasin(props) {
  const [reportData, setReportData] = useState();
  const [eventsData, setEventsData] = useState();
  const [areaDataInj, setAreaDataInj] = useState();
  const [areaDataFat, setAreaDataFat] = useState();

  const onFilterDataChanged = useCallback((data) => {
    setReportData([...data]);
    var fd = groupBy(data, 'Area/Basin')
    var fd1 = data.filter(item => (parseInt(item['Number of Fatalities']) || 0) !== 0);
    setAreaDataFat([...fd1]);
    fd1 = groupBy(fd1, 'Area/Basin')
    for (const key in fd1) {
      fd[key].fatalities = 0;
      for (var i=0; i<fd1[key].length; i++){
        fd[key].fatalities = fd[key].fatalities + (parseInt(fd[key][i]['Number of Fatalities']) || 0)
      }
    }
    //fd1 = data.filter(item => item['Potential or Actual SIF']==="Actual");
    fd1 = data.filter(item => (parseInt(item['Number of Serious Injuries']) || 0) !== 0);
    setAreaDataInj([...fd1]);
    fd1 = groupBy(fd1, 'Area/Basin')
    for (const key in fd1) {
      fd[key].injuries = 0;
      for (i=0; i<fd1[key].length; i++){
        fd[key].injuries = fd[key].injuries + (parseInt(fd[key][i]['Number of Serious Injuries']) || 0)
      }
    }
    fd = Object.keys(fd).map((key) => ({name: key, events: fd[key].length, injuries: (fd[key].injuries || 0), fatalities: (fd[key].fatalities || 0)}));
    fd = fd.sort((a,b) => (a.events > b.events) ? 1 : ((b.events > a.events) ? -1 : 0))
    setEventsData(fd);

  }, [setEventsData]);

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${pointInfo.argumentText}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].valueText} (${pointInfo.points[i].percentText})</div>`
      }
      txt=txt+`</div></div>`
    }
    return {
      html: txt,
    }
  }, []);

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={true}
        showDisciplines={true}
        showActivities={true}
        showPrimaryFactor={true}
        showPotentialActual={false}
        showCategories={true}
        showTimeOfDay={true}
      />
      <SIFMap
        accentColorRGB={'0, 162, 200,'}
        data={reportData}
        title={"Events by Basin"}
      />
      <SIFMap
        accentColorRGB={'20, 77, 109,'}
        data={areaDataInj}
        title={"Injuries by Basin"}
      />
      <SIFMap
        accentColorRGB={'237, 78, 32,'}
        data={areaDataFat}
        title={"Fatalities by Basin"}
      />


      <Chart
        id="chart"
        dataSource={eventsData}
        rotated={true}
        title="Events by Basin"
      >
        <ArgumentAxis>
          <Label
            wordWrap="normal"
            position="inside"
          />
        </ArgumentAxis>
        <Series type="bar"
          argumentField="name"
          valueField="events"
          name="Events"
          color="rgba(0, 162, 200, 1)"
        />
        <Series type="bar"
          argumentField="name"
          valueField="injuries"
          name="Injuries"
          color="rgba(20, 77, 109, 1)"
        />
        <Series type="bar"
          argumentField="name"
          valueField="fatalities"
          name="Fatalities"
          color="rgba(237, 78, 32, 1)"
        />
        <ValueAxis>
          <Label
            wordWrap="breakWord"
            position="outside"
          />
        </ValueAxis>
        <Legend />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>



      <SIFReportingCompanies data={reportData}/>
    </div>
  );
}
